
export const DOC_SEALED_STATUSES = ['REVOKED', 'ARCHIVED', 'DELETED'];
